import Vue from 'vue'

// import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vue.use(BootstrapVue)

import { LayoutPlugin, FormInputPlugin, ButtonPlugin, ImagePlugin, NavbarPlugin, LinkPlugin, FormPlugin, FormTextareaPlugin, InputGroupPlugin, FormGroupPlugin } from 'bootstrap-vue'
let plugins = [ LayoutPlugin, FormInputPlugin, ButtonPlugin, ImagePlugin, NavbarPlugin, LinkPlugin, FormPlugin, FormTextareaPlugin, InputGroupPlugin, FormGroupPlugin ]
for (let plugin of plugins) {
  Vue.use(plugin)
}
